<template>
  <el-dialog
    class="area"
    title="编辑分区信息"
    :visible.sync="dialogVisible"
    width="500px;"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <div class="list" v-if="resData.subregions.length > 0">
      <div class="li" v-for="item in resData.subregions" :key="item.index">
        <div class="info">
          <div class="left">分区编号:</div>
          <div class="right">{{ item.index }}</div>
        </div>
        <div class="info">
          <div class="left">分区名称:</div>
          <div class="right">
            <el-input
              v-model.trim="item.name"
              size="small"
              placeholder="请输入分区名称"
              :disabled="areaInfo.isAccessTp == 1 ? true : false"
            ></el-input>
          </div>
        </div>
        <div class="info">
          <div class="left">分区开关:</div>
          <div class="right">
            <el-select
              v-model="item.value"
              size="small"
              placeholder="请选择分区开关"
              :disabled="areaInfo.isAccessTp == 1 ? true : false"
            >
              <el-option label="开启" value="1"> </el-option>
              <el-option label="关闭" value="2"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <div>暂无分区信息</div>
    </div>
    <span slot="footer" class="dialog-footer" v-if="areaInfo.isAccessTp == 0">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button
        v-if="resData.subregions.length > 0"
        size="small"
        type="primary"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "BroadcastBindingArea",
  components: {},
  props: {
    areaInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    areaResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      resData: {
        id: "",
        areaName: "",
        areaNum: "",
        subregions: []
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    areaResize: function(newVal, oldVal) {
      if (newVal) {
        this.getBroadcastBindingArea();
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    submit() {
      // if (this.selectBroadcastCatalogIdTemp == "") {
      //   this.$message("请选择资源广播！");
      //   return;
      // }
      this.editBroadcastBindingArea();
      this.dialogVisible = false;
    },

    // 校园广播区域（获取分区信息）
    async getBroadcastBindingArea() {
      let req = {
        schoolId: this.$store.state.schoolId,
        areaNum: this.areaInfo.areaNum
      };
      let res = await this.$Http.getBroadcastBindingArea(req);
      if (res.code == 200) {
        this.resData = res.data[0];
        this.dialogVisible = true;
      } else if (res.code == 101) {
        this.resData = {
          id: "",
          areaName: "",
          areaNum: "",
          subregions: []
        };
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 校园广播区域（编辑分区信息）
    async editBroadcastBindingArea() {
      let req = {
        areaNum: this.resData.areaNum,
        chlist: this.resData.subregions
      };
      let res = await this.$Http.editBroadcastBindingArea(req);
      if (res.code == 200) {
        this.handleClose();
        this.$emit("getList");
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  padding: 10px 40px;
  height: 600px;
  overflow: scroll;
  .li {
    margin-bottom: 20px;
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px;
  }
  .left {
    width: 100px;
  }
  .right {
    .el-input,
    .el-select {
      width: 230px;
    }
  }
}
.no-data {
  padding: 10px 40px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
